import * as React from 'react';

import { translate } from '~l10n/client';
import Backbone from 'backbone';
import cx from 'classnames';

import { Tab, TabGroup } from '~shared/components/TabsV2';

import * as Constants from '../../../../../shared/Constants';
import CloseX from '../../../../shared/components/buttons/CloseX';
import AlertIcon from '../../../../shared/icons/AlertIcon';
import SuccessIcon from '../../../../shared/icons/SuccessIcon';

interface Props {
  closeBannerClicked?: () => void;
  bannerMessage?: string;
  bannerType?: number;
  selectedTab: string;
}

export default function ProfileTabs({
  bannerMessage,
  bannerType,
  closeBannerClicked,
  selectedTab,
}: Props) {
  const handleTabClick = (selectedItem: string) => {
    Backbone.history.navigate(selectedItem, { trigger: true });
  };

  const bannerClass = cx(
    bannerType === Constants.BANNER_TYPE_SUCCESS
      ? 'profile-success-banner'
      : 'profile-error-banner'
  );

  return (
    <>
      <TabGroup
        className="trackless"
        activation="manual"
        onSlTabShow={(e) => handleTabClick((e as any).detail.name)}
      >
        <Tab
          slot="nav"
          panel={Constants.PROFILE_INFO}
          onClick={() => handleTabClick(Constants.PROFILE_INFO)}
          active={selectedTab === Constants.PROFILE_INFO}
        >
          {translate('Profile')}
        </Tab>
        <Tab
          slot="nav"
          panel={Constants.PROFILE_DEMO}
          onClick={() => handleTabClick(Constants.PROFILE_DEMO)}
          active={selectedTab === Constants.PROFILE_DEMO}
        >
          {translate('Demographics')}
        </Tab>
        <Tab
          slot="nav"
          panel={Constants.PROFILE_BILLING}
          onClick={() => handleTabClick(Constants.PROFILE_BILLING)}
          active={selectedTab === Constants.PROFILE_BILLING}
        >
          {translate('Account')}
        </Tab>
      </TabGroup>
      {bannerMessage ? (
        <>
          {bannerType === Constants.BANNER_TYPE_ERROR ? (
            <div
              className="profile-banner-error-close"
              onClick={closeBannerClicked}
            >
              <CloseX className="profile-banner-error-close-x" />
            </div>
          ) : null}
          <div className={bannerClass}>
            {bannerType ? (
              <SuccessIcon className="profile-banner-icon" color="#ffffff" />
            ) : (
              <AlertIcon className="profile-banner-icon" color="#ffffff" />
            )}
            <span className="profile-banner-text">{bannerMessage}</span>
          </div>
        </>
      ) : null}
    </>
  );
}
